export let monthList = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUNE",
  "JULY",
  "AUG",
  "SEPT",
  "OCT",
  "NOV",
  "DEC",
];

export function convertDate(inputFormat) {
  if (inputFormat && inputFormat !== "") {
    let date = new Date(inputFormat);
    return [
      pad(date.getDate()),
      pad(date.getMonth() + 1),
      date.getFullYear(),
    ].join("/");
  }
  return "-";
}
export const convertToDD_MMM_YYY = (inputFormat) => {
  if (inputFormat && inputFormat !== "") {
    const date = inputFormat?.split("-");
    return [date?.[0], monthList[parseInt(date?.[1]) - 1], date?.[2]].join("-");
  }
  return "-";
};

export function convertDateDashYMD(inputFormat) {
  if (inputFormat && inputFormat !== "") {
    let date = new Date(inputFormat);
    return [
      date.getFullYear(),
      pad(date.getMonth() + 1),
      pad(date.getDate()),
    ].join("-");
  }
  return "-";
}

export function convertDateDashDMY(inputFormat) {
  if (inputFormat && inputFormat !== "") {
    let date = new Date(inputFormat);
    return [
      pad(date.getDate()),
      monthList[parseInt(date.getMonth())],
      date.getFullYear(),
    ].join("-");
  }
  return "-";
}

export function converDateToDateTime(date) {
  if (date) {
    const dateString = [
      date.getFullYear(),

      pad(date.getMonth() + 1),
      pad(date.getDate()),
    ].join("-");
    const fullDateString =
      dateString + " " + date.toLocaleTimeString("en-US", { hour12: false });
    return fullDateString;
  }
  return "-";
}

export function converDateToDateTime_DD_MM_YY(date) {
  if (date) {
    const dateString = [
      pad(date.getDate()),
      pad(date.getMonth() + 1),
      date.getFullYear(),
    ].join("-");
    const fullDateString =
      dateString + " " + date.toLocaleTimeString("en-US", { hour12: false });
    return fullDateString;
  }
  return "-";
}
export function pad(input) {
  return input < 10 ? "0" + input : input;
}
export function padPO(input) {
  if (typeof input === "number") {
    return input?.toString()?.length < 10
      ? "0".repeat(10 - input.toString().length) + input
      : input;
  }
  if (input) {
    return input.length < 10 ? "0".repeat(10 - input.length) + input : input;
  }
  return input;
}
export function padPONotAlpha(input) {
  const regExp = /[a-zA-Z]/g;
  if (typeof input === "number") {
    return input?.toString()?.length < 10
      ? "0".repeat(10 - input.toString().length) + input
      : input;
  }
  if (regExp.test(input)) {
    return input;
  } else {
    return input.length < 10 ? "0".repeat(10 - input.length) + input : input;
  }
}
export function padAppointmentId(input) {
  if (input) {
    return input?.toString()?.length < 12
      ? "0".repeat(12 - input?.toString()?.length) + input?.toString()
      : input;
  }
  return null;
}
export function padGSTIN(input) {
  if (input) {
    return input?.toString()?.length < 15
      ? "0".repeat(15 - input?.toString()?.length) + input?.toString()
      : input;
  }
  return null;
}

export function toUpperCase(input) {
  if (typeof input !== "string") {
    return input.toString().toUpperCase();
  } else {
    return input.toUpperCase();
  }
}
export function hasNumber(str) {
  let numberFormat = /\d/;
  return numberFormat.test(str);
}
export function containSpecialCharacters(str) {
  let specialCharacterFormat = /[ `!@#$%^&* ]/;
  return specialCharacterFormat.test(str);
}

export function hasLowerCase(str) {
  return str?.toUpperCase() !== str;
}
export function hasUpperCase(str) {
  return str?.toLowerCase() !== str;
}
export function lengthGreaterThan(length, str) {
  if (str && str.length >= length) {
    return true;
  } else {
    return false;
  }
}

export function confirmMatchedPassword(confirmPassword, password) {
  if (confirmPassword?.length > 0 && password?.length > 0) {
    return password === confirmPassword;
  } else {
    return false;
  }
}

export const convertTime = (str) => {
  if (str) {
    const strArr = str?.split(":");

    if (strArr?.[0] >= "12") {
      return strArr?.[0] + ":" + strArr?.[1];
    } else {
      return strArr?.[0] + ":" + strArr?.[1];
    }
  }
};

export const parseToFormData = (data) => {
  return {
    appointmentId: data?.appointmentId,
    appointmentDate: new Date(data?.appointmentDate),
    startTime: convertTime(data?.appointmentStartTime),
    endTime: convertTime(data?.appointmentEndTime),
    appointmentType: data?.appointmentType,
    asn: data?.asn,
    GSTIN: data?.gstIn,
    dockId: data?.dockId,
    fcCode: data?.fcCode,
    countOfvehicle: data?.countOfVehicle,
    vendorCode: data?.vendorCode,
    timeSlotRefId: data?.timeSlotRefId,
    poDetails: data?.poParams,
    poCount: data?.poParams?.length,
    vehicleDetails: data?.vehicleParams,
    bookingType: data?.bookingType,
    appointmentArticles: data?.articleParams,
  };
};

export const errorHandler = (notificationMethod, err, defaultMessage) => {
  if (!!err && !!err.message) {
    if (
      err?.message
        ?.toLowerCase()
        ?.includes("cannot read properties of undefined")
    ) {
      notificationMethod("Error", defaultMessage);
    } else {
      notificationMethod("Error", err.message);
    }
  } else {
    notificationMethod("Error", defaultMessage);
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case 1:
    case 4:
    case 3:
      return "#4caf50";

    case 2:
    case 0:
      return "#ff9800";
    case 7:
    case 6:
      return "#ef5350";
    case 5:
      return "#efaa50";
    default:
      return "#8b8a8a";
  }
};

export function isEmptyObject(obj) {
  for (let prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      if (obj[prop] === null) {
        continue;
      } else if (typeof obj[prop] === "string") {
        if (obj[prop].length !== 0) {
          return false;
        }
      } else if (typeof obj[prop] === "number") {
        if (obj[prop] > 0) {
          return false;
        }
      } else if (Object.keys(obj[prop]).length) {
        return false;
      }
    }
  }
  return true;
}
export function isValidDate(str) {
  // eslint-disable-next-line no-useless-escape
  let parms = str.split(/[\.\-\/]/);
  let yyyy = parseInt(parms[2], 10);
  let mm = parseInt(parms[1], 10);
  let dd = parseInt(parms[0], 10);
  let date = new Date(yyyy, mm - 1, dd, 0, 0, 0, 0);
  return (
    mm === date.getMonth() + 1 &&
    dd === date.getDate() &&
    yyyy === date.getFullYear()
  );
}

export function shortenFileName(str) {
  if (str.length > 30) {
    return str.substr(0, 26) + "..." + str.substr(-4);
  }

  return str;
}
export function dateHash(inputDate) {
  if (inputDate) {
    return [
      inputDate.getFullYear(),

      pad(inputDate.getMonth() + 1),
      pad(inputDate.getDate()),
    ].join("-");
  } else {
    return "-";
  }
}

export const isDateGreaterThan = (from, to) => {
  if (from && to) {
    const firstDate = new Date(
      from.getFullYear(),
      from.getMonth(),
      from.getDate()
    );
    const secondDate = new Date(to.getFullYear(), to.getMonth(), to.getDate());

    return firstDate >= secondDate;
  }
  return null;
};
export const checkIfJwt = (token) => {
  try {
    if (token && token !== "") {
      const parsed = JSON.parse(atob(token.split(".")[1]));
      return !!parsed;
    }
  } catch (e) {
    return false;
  }
};
export const convertDateFromUTCString = (date) => {
  if (date) {
    // eslint-disable-next-line no-useless-escape
    let parms = date.split(/[\.\-T\/]/);
    let yyyy = parseInt(parms[0], 10);
    let mm = parseInt(parms[1], 10);
    let dd = parseInt(parms[2], 10);
    return pad(dd) + "-" + monthList[pad(mm) - 1] + "-" + pad(yyyy);
  } else return "-";
};
export const isSameDate = (from, to) => {
  if (from && to) {
    const sameYear = from.getFullYear() === to.getFullYear();
    const sameMonth = from.getMonth() === to.getMonth();
    const sameDay = from.getDate() === to.getDate();

    return sameYear && sameMonth && sameDay;
  }
  return null;
};

export const isCountOfSkusGT = (newFormData, oldFormData) => {
  if (oldFormData && newFormData) {
    let oldNoOfCases = 0;
    let newNoOfCases = 0;

    oldFormData?.poDetails?.forEach((element) => {
      oldNoOfCases += parseInt(element?.noOfCases);
    });
    newFormData?.poDetails?.forEach((element) => {
      newNoOfCases += parseInt(element?.noOfCases);
    });
    return newNoOfCases > oldNoOfCases;
  }
  return false;
};

export const convertToUpperCase = (s) => {
  if (s && typeof s === "string") {
    return s?.toUpperCase();
  } else {
    return s;
  }
};

export function convertDateToDateTimeStringwithDash(inputFormat) {
  if (inputFormat && inputFormat !== "") {
    let date = new Date(inputFormat);
    const dateString = [
      pad(date.getDate()),
      monthList[date.getMonth()],
      date.getFullYear(),
    ].join("-");

    const timeString =
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes()) +
      ":" +
      pad(date.getSeconds());

    return dateString + " , " + timeString;
  }
  return "-";
}

export const stripSecondsFromTime = (time) => {
  if (time) {
    const timeArr = time?.split(":");
    return `${timeArr?.[0]}:${timeArr?.[1]}`;
  }
  return time;
};
export function deepEqual(x, y) {
  const ok = Object.keys,
    tx = typeof x,
    ty = typeof y;
  return x && y && tx === "object" && tx === ty
    ? ok(x).length === ok(y).length &&
        ok(x).every((key) => deepEqual(x[key], y[key]))
    : x === y;
}

// export function deriveIndex(poDetails, poList) {
//   return poDetails.findIndex(
//     (field) =>
//       field.poNumber === poList.poNumber ||
//       padPO(field.poNumber) === poList.poNumber
//   );
// }

export function deriveIndex(poDetails, poList, index) {
  return poDetails.findIndex(
    (field) =>
      field.poNumber === poList.poNumber ||
      padPO(field.poNumber) === poList.poNumber ||
      field.poNumber === poList.asnNumber ||
      padPO(field.poNumber) === poList.asnNumber
  );
}

export function getPOLatestDeliveryDate(poList) {
  if (!poList?.latestPODeliveryDate) return null;
  let dateArr = poList?.latestPODeliveryDate?.split(".");
  return new Date(dateArr[2], dateArr[1] - 1, dateArr[0]);
}

export function getPOEarliestDeliveryDate(poList) {
  if (!poList?.earliestPODeliveryDate) return null;
  let dateArr = poList?.earliestPODeliveryDate?.split(".");
  return new Date(dateArr[2], dateArr[1] - 1, dateArr[0]);
}

export function getPODeliveryDate(poList) {
  let dateArr = poList?.latestPODeliveryDate?.split(".");

  let poDeliveryDate = new Date(dateArr?.[2], dateArr?.[1] - 1, dateArr?.[0]);
  return poDeliveryDate;
}

export function setError2(setError, resultIndex, poList) {
  setError(`poDetails[${resultIndex}].poNumber`, {
    type: "manual",
    message:
      poList?.responseType?.toUpperCase() === "E"
        ? poList?.responseMessage
        : "Please Provide Valid PO",
  });
  console.error(
    "Order validtion check | 2 | Error | Order | " + poList.poNumber
  );
}

export function setError1(setError, resultIndex, poList) {
  setError(`poDetails[${resultIndex}].poNumber`, {
    type: "manual",
    message:
      poList?.responseType?.toUpperCase() === "S"
        ? "Delivery date lapsed for the PO. Please contact replenishment team"
        : "Please Provide Valid PO / ASN",
  });
  console.warn(
    "Order validtion check | 1 | DateTime | Order | " + poList.poNumber
  );
}

export function setError4(setError, resultIndex, poList) {
  setError(`poDetails[${resultIndex}].poNumber`, {
    type: "manual",
    message:
      poList?.responseType?.toUpperCase() === "E"
        ? poList?.responseMessage
        : "Please Provide Valid PO",
  });
  console.error(
    "Order validtion check | 4 | Error | Order | " + poList.poNumber
  );
}

export function setError3(setError, resultIndex, poList) {
  setError(`poDetails[${resultIndex}].poNumber`, {
    type: "manual",
    message:
      poList?.responseType?.toUpperCase() === "S"
        ? "Delivery date lapsed for the PO. Please contact replenishment team"
        : "Please Provide Valid PO / ASN",
  });
  console.warn(
    "Order validtion check | 3 | DateTime | Order | " + poList.poNumber
  );
}

export function setError5(setError, resultIndex, poList) {
  setError(`poDetails[${resultIndex}].poNumber`, {
    type: "manual",
    message: `Invalid Site code `,
  });
  console.error(
    "Order validation check | 5 | Missing physicalSiteCode | Order | " +
      (poList?.poNumber || "N/A")
  );
}

export function getPOOnly(poDetails) {
  return poDetails
    ?.filter(
      (poElement) =>
        Number(poElement.inputTypeId) === 1 || poElement.inputTypeId === null
    )
    ?.map((poElement) => padPO(poElement.poNumber));
}

export function getASNOnly(poDetails) {
  return poDetails
    ?.filter((poElement) => Number(poElement.inputTypeId) === 2)
    ?.map((poElement) => padPO(poElement.poNumber));
}

export function compareDeliveryDateAndCurrentDate(poDeliveryDate, currentDate) {
  return new Date(poDeliveryDate).getTime() <= currentDate.getTime();
}

export function checkOrderAPIResponseIsSuccess(poList) {
  return poList?.responseType?.toUpperCase() === "S";
}

export function checkOrderAPIResponseIsError(poList) {
  return poList?.responseType?.toUpperCase() === "E";
}
